import * as React from 'react'

interface Props {
  message: React.ReactNode
  requestId?: string
}

export function ErrorToastBody({ message, requestId }: Props) {
  const handleCopy = React.useCallback(() => {
    if (requestId) navigator.clipboard?.writeText(requestId)
  }, [requestId])

  return (
    <div className="flex flex-col gap-1">
      {/* pre-line: a 422 can carry one line per bad routing row, and a plain
          div would run them together into one unreadable sentence. */}
      <div className="whitespace-pre-line">{message}</div>
      {requestId && (
        <button
          type="button"
          className="text-xs text-muted-foreground text-left hover:underline"
          onClick={handleCopy}
        >
          Error code: {requestId.slice(0, 8)} (click to copy)
        </button>
      )}
    </div>
  )
}
